import * as React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Stack } from "office-ui-fabric-react";
// import DashboardPage from "../pages/DashboardPage";
// import { AuthenticatedRoute } from "./common/AuthenticatedRoute";
// import LoginPage from "../pages/auth/LoginPage";
// import NotAuthorizedPage from "../pages/common/NotAuthorizedPage";
// import Page404 from "../pages/common/Page404";
import NavBar from "./common/NavBar";
// import DatacenterListPage from "../pages/DatacentersListPage";
// import DataCenterPage from "../pages/DataCenterPage";
// import UpsMain from "./infrastructure/ups/UpsMain";
// import TransformerMain from "./infrastructure/transformer/TransformerMain";
// import HtPanelMain from "./infrastructure/ht-panel/HtPanelMain";
// import SmpsMain from "./infrastructure/smps/SmpsMain";
// import PacMain from "./infrastructure/pac/PacMain";
// import DgSetMain from "./infrastructure/dg-set/DgSetMain";
// import AirCooledChillerMain from "./infrastructure/air-cooled-chiller/AirCooledChillerMain";
// import IdcTemperatureMain from "./infrastructure/idc-temperature/IdcTemperatureMain";
// import CustomerMain from "./customers/CustomerMain";
// import CustomerDetails from "./customers/CustomerDetails";
// import AccessLogsMain from "./customers/access-logs/AccessLogsMain";
// import TemperatureHumidityMain from "./customers/temperature-humidity/TemperatureHumidityMain";
// import PowerUtilizatioMain from "./customers/power-utilization/PowerUtilizationMain";
// import AdminMain from "./admins/AdminMain";
// import SystemConfigMain from "./system-config/SystemConfigMain";
// import CCTVImageMain from "./customers/cctv-image/CCTVImageMain";
// import UpTimeMain from "./customers/up-time/UpTimeMain";
// import TicketMain from "./customers/tickets/TicketMain";
// import SlaMatrixMain from "./sla-matrix/SlaMatrixMain";
// import SlaMatrix from "./customers/sla-matrix/SlaMatrix";
// import TempAndRhMain from "./infrastructure-automation/temp-rh/TempAndRhMain";
// import PowerUtilizationMain from "./customers/power-utilization/PowerUtilizationMain";
// import PowerUtilizatioReadingMain from "./infrastructure-automation/power-utilization/PowerUtilizationMain";
// import AuthorizationContacts from "./customers/authorization-contacts/AuthorizationContacts";
// import ServiceDetails from "./customers/service-details/ServiceDetails";
// import PreviousMeeting from "./customers/previous-meetings/PreviousMeeting";
// import AssignEscalationMatrix from "./customers/assign-escalation-matrix/AssignEscalationMatrix";
// import ChangePasswordPage from "./change-password/ChangePasswordPage";
import RoutesMain from "./RoutesMain";
// import { IPublicClientApplication } from "@azure/msal-browser";

export interface RoutesProps {
  // msalInstance: IPublicClientApplication
}

export interface RoutesState {}

class Routes extends React.Component<RoutesProps, RoutesState> {
  render() {
    return (
      <Router>
        <div className="app-container">
          <NavBar />
          <Stack horizontal>
            <Stack.Item grow styles={{ root: { overflow: "auto" } }}>
              <RoutesMain />
              {/* <main className="main-container">
                <Switch>
                  <Route path="/login" exact component={LoginPage} />
                  <AuthenticatedRoute
                    path="/"
                    exact
                    component={DashboardPage}
                  />
                  <AuthenticatedRoute
                    path="/datacenters"
                    exact
                    component={DatacenterListPage}
                  />

                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/transformer"
                    exact
                    component={TransformerMain}
                  />

                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId"
                    exact
                    component={DataCenterPage}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/ups"
                    exact
                    component={UpsMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/ht-panel"
                    exact
                    component={HtPanelMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/smps"
                    exact
                    component={SmpsMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/pac"
                    exact
                    component={PacMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/dg-set"
                    exact
                    component={DgSetMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/cooled-chiller"
                    exact
                    component={AirCooledChillerMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure/idc-temperature"
                    exact
                    component={IdcTemperatureMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure-automation/temp-rh"
                    exact
                    component={TempAndRhMain}
                  />
                  <AuthenticatedRoute
                    path="/datacenters/:dataCenterId/infrastructure-automation/power-utilization"
                    exact
                    component={PowerUtilizatioReadingMain}
                  />
                  <AuthenticatedRoute
                    path="/customers"
                    exact
                    component={CustomerMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId"
                    exact
                    component={CustomerDetails}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/access-logs"
                    exact
                    component={AccessLogsMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/temperature-humidity"
                    exact
                    component={TemperatureHumidityMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/power-utilization"
                    exact
                    component={PowerUtilizatioMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/cctv-image"
                    exact
                    component={CCTVImageMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/up-time"
                    exact
                    component={UpTimeMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/service-tickets"
                    exact
                    component={TicketMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/incidents"
                    exact
                    component={TicketMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/remote-hand-services"
                    exact
                    component={TicketMain}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/sla-matrixes-config"
                    exact
                    component={SlaMatrix}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/authorized-contacts"
                    exact
                    component={AuthorizationContacts}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/service-details"
                    exact
                    component={ServiceDetails}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/previous-meetings"
                    exact
                    component={PreviousMeeting}
                  />
                  <AuthenticatedRoute
                    path="/customers/:customerId/assign-escalation-matrix"
                    exact
                    component={AssignEscalationMatrix}
                  />
                  <AuthenticatedRoute
                    path="/admins"
                    exact
                    component={AdminMain}
                  />
                  <AuthenticatedRoute
                    path="/system-configs"
                    exact
                    component={SystemConfigMain}
                  />
                  <AuthenticatedRoute
                    path="/sla-matrixes"
                    exact
                    component={SlaMatrixMain}
                  />
                  <AuthenticatedRoute
                    path="/change-password"
                    exact
                    component={ChangePasswordPage}
                  />
                  <Route
                    path="/not-authorized"
                    exact
                    component={NotAuthorizedPage}
                  />
                  <Route path="" exact component={Page404} />
                </Switch>
              </main> */}
            </Stack.Item>
          </Stack>
        </div>
      </Router>
    );
  }
}

export default Routes;
